import React from 'react';
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_d7a39a59-63ba-4bd9-b746-de38b35bd039/artifacts/rsx786qh_WhatsApp%20Image%202026-04-08%20at%2017.50.03.jpeg" 
              alt="Visaspot" 
              className="h-12 w-auto mb-4 bg-white p-2 rounded"
            />
            <p className="text-gray-300 mb-6">
              Your trusted partner for overseas education and immigration. Turning dreams into reality since 2010.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#FF7043] flex items-center justify-center transition-all duration-300">
                <Facebook size={18} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#FF7043] flex items-center justify-center transition-all duration-300">
                <Twitter size={18} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#FF7043] flex items-center justify-center transition-all duration-300">
                <Instagram size={18} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#FF7043] flex items-center justify-center transition-all duration-300">
                <Linkedin size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-white">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('home')} className="text-gray-300 hover:text-[#8BC34A] transition-colors flex items-center gap-2 group">
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-300 hover:text-[#8BC34A] transition-colors flex items-center gap-2 group">
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('countries')} className="text-gray-300 hover:text-[#8BC34A] transition-colors flex items-center gap-2 group">
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                  Countries
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-300 hover:text-[#8BC34A] transition-colors flex items-center gap-2 group">
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-300 hover:text-[#8BC34A] transition-colors flex items-center gap-2 group">
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-white">Our Services</h3>
            <ul className="space-y-3">
              <li className="text-gray-300 hover:text-[#8BC34A] transition-colors cursor-pointer">Study Abroad Consulting</li>
              <li className="text-gray-300 hover:text-[#8BC34A] transition-colors cursor-pointer">Immigration Services</li>
              <li className="text-gray-300 hover:text-[#8BC34A] transition-colors cursor-pointer">Student Visa Assistance</li>
              <li className="text-gray-300 hover:text-[#8BC34A] transition-colors cursor-pointer">Work Permit & PR</li>
              <li className="text-gray-300 hover:text-[#8BC34A] transition-colors cursor-pointer">Language Test Prep</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-white">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={20} className="text-[#FF7043] mt-1 flex-shrink-0" />
                <span className="text-gray-300">
                  F.No-109, C B Eastern Homes,<br />
                  Above Bank of Maharashtra, Kamala Nagar,<br />
                  Dilsukhnagar, Hyderabad, Telangana-500068
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={20} className="text-[#FF7043] flex-shrink-0" />
                <a href="tel:9052808055" className="text-gray-300 hover:text-[#8BC34A] transition-colors">
                  +91 905-280-8055
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={20} className="text-[#FF7043] flex-shrink-0" />
                <a href="mailto:info@thevisaspot.com" className="text-gray-300 hover:text-[#8BC34A] transition-colors">
                  info@thevisaspot.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © 2026 Visaspot. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-[#8BC34A] transition-colors">Privacy Policy</a>
              <a href="#" className="text-gray-400 hover:text-[#8BC34A] transition-colors">Terms of Service</a>
              <a href="#" className="text-gray-400 hover:text-[#8BC34A] transition-colors">Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
